import { SVGProps, Ref, forwardRef } from "react";

const FormatItalicIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Format Italic Icon"
    {...props}
  >
    <title id="Format Italic Icon">Format Italic Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 4h-9m4 16H5M15 4 9 20"
    />
  </svg>
);

const ForwardRef = forwardRef(FormatItalicIcon);
export default ForwardRef;
